import { __awaiter } from "tslib";
/**
 * @ignore
 */
export function identity(x) {
    return x;
}
/**
 * @ignore
 */
export function identityAsync(x) {
    return __awaiter(this, void 0, void 0, function* () {
        return x;
    });
}

//# sourceMappingURL=identity.mjs.map
